
import { useEffect } from "react";

export const useSessionLogger = (session: any, isNewUser: boolean) => {
  useEffect(() => {
    if (session?.user) {
      console.log("User session data:", {
        id: session.user.id,
        email: session.user.email,
        provider: session.user.app_metadata?.provider,
        providers: session.user.app_metadata?.providers,
        has_set_password: session.user.user_metadata?.has_set_password,
        has_seen_password_prompt: session.user.user_metadata?.has_seen_password_prompt,
        isNewUser: isNewUser
      });
    }
  }, [session, isNewUser]);
};
